module.exports = __webpack_public_path__ + "static/media/5S.5ab3d862.png";